import { AsyncComponent } from '@frontend/components/common';
import { lazy } from 'react';
import { Route } from 'react-router-dom';

import DeprecatedFeatureLayout from '../components/deprecated-feature-layout/deprecated-feature-layout.component';

const ProductKitOverview = lazy(() => import('./product-kit-overview'));
const ProductKitCreate = lazy(() => import('./product-kit-create/product-kit-create.component'));
const ProductKitDetail = lazy(() => import('./product-kit-detail/product-kit-detail.component'));
const ProductKitUpdate = lazy(() => import('./product-kit-update/product-kit-update.component'));

export function ProductKitRoutes() {
    return (
        <Route
            path='product-kits'
            element={<DeprecatedFeatureLayout />}>
            <Route
                index
                element={
                    <AsyncComponent>
                        <ProductKitOverview />
                    </AsyncComponent>
                }
            />
            <Route
                path='create'
                element={
                    <AsyncComponent>
                        <ProductKitCreate />
                    </AsyncComponent>
                }
            />
            <Route path=':productKitId'>
                <Route
                    path='detail'
                    element={
                        <AsyncComponent>
                            <ProductKitDetail />
                        </AsyncComponent>
                    }
                />
                <Route
                    path='update'
                    element={
                        <AsyncComponent>
                            <ProductKitUpdate />
                        </AsyncComponent>
                    }
                />
            </Route>
        </Route>
    );
}
